// extracted by mini-css-extract-plugin
export default {"background":"Account_background__WyQqZ","sendEmailBtn":"Account_sendEmailBtn__TUFBG"};